var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column justify-center items-center h100-vh"},[_c('van-icon',{attrs:{"name":"passed","color":"#004ff0","size":"0.8rem"}}),_c('div',{staticClass:"f40 fb mar20-t mar50-b"},[_vm._v("注册成功")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }